import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AutentificacionService } from '../_services/autentificacion.service';
import { RolUsuario } from '../_models/_enums/rolUsuario.enum';
import { SnackBarService } from '../_helpers/snack-bar.service';

export const proveedorGuard: CanActivateFn = (route, state) => {
  const authService = inject(AutentificacionService);
  const navCtrl = inject(NavController);
  const snackBarService = inject(SnackBarService);
  const usuario = authService.userInfo;

  // Si el usuario no es proveedor, permitir el acceso
  if (!usuario || usuario.rol !== RolUsuario.Proveedor) {
    return true;
  }

  // Si es proveedor, validar que tenga idProveedor
  if (!usuario.idProveedor) {
    // Si no tiene idProveedor, no permitir acceso
    return false;
  }

  const currentUrl = state.url;
  const rutaProveedorPermitida = `/proveedores/ficha/${usuario.idProveedor}`;
  const rutaMiCuentaPermitida = '/cuenta';
  const rutaArticulosFichaPattern = /^\/articulos\/ficha\/.*$/;

  // Verificar si la ruta actual es una de las permitidas
  const esRutaProveedorPermitida = currentUrl === rutaProveedorPermitida || currentUrl.startsWith(rutaProveedorPermitida);
  const esRutaArticuloPermitida = rutaArticulosFichaPattern.test(currentUrl);
  const esRutaMiCuentaPermitida = currentUrl === rutaMiCuentaPermitida;
  
  // Si la ruta no es permitida, redirigir a la ficha del proveedor
  if (!esRutaProveedorPermitida && !esRutaArticuloPermitida && !esRutaMiCuentaPermitida) {
    // /proveedores es la ruta base a la que redirige la aplicación. Por lo que no muestra el mensaje
    // de error
    if (currentUrl !== '/proveedores') {
      snackBarService.showError('Acceso denegado.');
    }
    navCtrl.navigateRoot(rutaProveedorPermitida);
    return false;
  }

  return true;
};
